import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('m_buyer')
export class BuyerEntity extends CommonFieldsModel {
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: number;

    @Column('varchar', {
        nullable: false,
        length: 100,
        name: 'buyer_name'
    })
    buyerName: string;

    @Column('varchar', {
        nullable: false,
        length: 100,
        name: 'buyer_code'
    })
    buyerCode: string;

    @Column('text', {
        nullable: true,
        name: 'line_desc'
    })
    buyerDesc: string;
}